module.exports = __webpack_public_path__ + "img/video_nav.3d21fdba.png";